
import { CLEAR_CATEGORY_SLUG, NOT_IS_DYNAMIC, SET_CATEGORY_SLUG, SET_IS_DYNAMIC } from "../actions/categoryAction";

const initialState = {
  categorySlug: {
    en: null,
    es: null,
    fr: null,
  },
  isDynamic:false
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CATEGORY_SLUG:
      return {
        ...state,
        categorySlug: action.payload,  
      };

    case CLEAR_CATEGORY_SLUG:
      return {
        ...state,
        categorySlug: { en: null, es: null, fr: null }, 
      };
      case SET_IS_DYNAMIC:
        return {
          ...state,
          isDynamic: action.payload,  // directly set the value of isDynamic
        };
  
      case NOT_IS_DYNAMIC:
        return {
          ...state,
          isDynamic: false,  // set isDynamic to false
        };

    default:
      return state;
  }
};


export default categoryReducer;